import { Stack, Typography } from '@mui/material';
import { AtLocator } from '@Components/shared/locators/AtLocator';

export const FailedSendCreditTasksTitle: React.FC = () => {
  return (
    <AtLocator type="container" name="ProviderTransactionsListTitle">
      <Stack
        direction="row"
        alignItems="center"
        justifyContent="space-between"
        sx={{ paddingBottom: 2 }}
      >
        <Stack direction="row" alignItems="center" justifyContent="space-between">
          <Typography variant="h3">Failed Send Credit Tasks</Typography>
        </Stack>
      </Stack>
    </AtLocator>
  );
};
